export default __webpack_public_path__ + "assets/error_screen_image.png";